module.exports = __webpack_public_path__ + "media/images/niq-tool-fb2a05ccc28ca1ded7b5fc853175ee7e.png";